export default "__VITE_ASSET__CFdcnEse__"